import { useEffect } from "react";
import { useDispatch } from "react-redux";
import api from "utils/api";
import { serializeFirebaseUser } from "utils/helpers";

import { setFirebaseToken, setProfile, signInUser } from "features/user/userSlice";
import useSignOutUser from "./useSignOutUser";

export default function useSignInWithFirebaseToken(firebaseToken) {
  const dispatch = useDispatch();
  const handleSignOut = useSignOutUser();

  const handleAuthUserChange = (userData) => {
    dispatch(signInUser(serializeFirebaseUser(userData)));
  };
  const handleSetFirebaseToken = (token) => {
    dispatch(setFirebaseToken(token));
  };

  const isVerifyEmailError = (error) => {
    const message = error?.response?.data?.error?.message || "";
    // Ensure message is a string and toLowerCase() returns a valid string
    const messageStr = String(message).toLowerCase();
    return messageStr.includes("email not verified");
  };

  const signInWithFbToken = async (firebaseToken) => {
    try {
      const verifyResponse = await api.verifyFirebaseToken(firebaseToken);
      const userData = verifyResponse.data;
      handleAuthUserChange(userData);
      handleSetFirebaseToken(firebaseToken);
      await fetchProfile(firebaseToken);
    } catch (e) {
      if (e?.response?.status === 401 && !isVerifyEmailError(e)) {
        // Clear any state
        handleSignOut();
      } else {
        console.error(e);
      }
    }
  };

  const fetchProfile = async (firebaseToken) => {
    const res = await api.getProfile(firebaseToken);
    dispatch(setProfile(res.data));
  };

  useEffect(() => {
    if (firebaseToken) {
      signInWithFbToken(firebaseToken);
    }
  }, []);

  return { signInWithFbToken };
}
